import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Login from '@/view/Login'
import Home from '@/view/user/home'
import Homeindex from '@/view/user/homeindex'
import ForgetPassword from '@/view/forgetPassword'

// 企业管理系统-企业端
//基础信息
import CompanyPositionManage from '@/view/user/baseInfo/positionManage' //职位管理
import CompanyOrgManage from '@/view/user/baseInfo/orgManage' //机构管理
import CompanyRolesManage from '@/view/user/baseInfo/companyRolesManage' //角色管理
import CompanyPersonManage from '@/view/user/baseInfo/personManage' //人员管理
import CompanyChangePassword from '@/view/user/baseInfo/companychangePassword' //修改密码
// 追溯码
import TraceCode from '@/view/user/traceCode/traceCode' //追溯码申请
import TraceCodeQuery from '@/view/user/traceCode/traceCodeQuery' //追溯码查询

// 企业出入库管理
import InWarehouse from '@/view/user/inAndOutWarehouse/inWarehouse' //入库管理
import OutWarehouse from '@/view/user/inAndOutWarehouse/outWarehouse' //出库管理
import StockManage from '@/view/user/inAndOutWarehouse/stockManage' //库存管理
// 扫一扫页面
import ScanIndex from '@/view/scanIndex'
import Scan0 from '@/view/scan0'
import Scan1 from '@/view/scan1'
import ScanCompanyInfo from '@/view/scanCompanyInfo'
import ScanBranding from '@/view/scanBranding'
import ScanTraceability from '@/view/scanTraceability'

//      运营端 
import SystemLogin from '@/view/system/login'
import SystemIndex from '@/view/system/index'
import SyStemHomeindex from '@/view/system/homeIndex'

// 基础信息管理
import OrgManage from '@/view/system/baseInfoManage/orgManage'
import PositionManage from '@/view/system/baseInfoManage/positionManage.vue'
import PersonManage from '@/view/system/baseInfoManage/personManage.vue'
import ChangePassword from '@/view/system/baseInfoManage/changePassword.vue'
import RolesPower from '@/view/system/baseInfoManage/rolesPower'
// 角色管理
import SystemRolesPage from '@/view/system/rolesManage/systemRolesPage.vue'
import CompanyUserPage from '@/view/system/rolesManage/companyUserPage.vue'
import CompanyUserSonPage from '@/view/system/rolesManage/companyUserSonPage.vue'
// 菜单管理
import NavigationSystemPage from '@/view/system/menuManage/navigationSystemPage.vue'
import NavigationCompanyPage from '@/view/system/menuManage/navigationCompanyPage.vue'
import ButtonsManage from '@/view/system/menuManage/buttonsManage.vue'
// 库存管理
import FatoryStockManage from '@/view/system/stockCenter/stockManage.vue' //库存管理
import FatoryOutWarehouse from '@/view/system/stockCenter/outWarehouse.vue' //出库管理
import FatoryInWarehouse from '@/view/system/stockCenter/inWarehouse.vue' //入库管理
//企业管理
import FactoryManage from '@/view/system/businessManage/factoryManage.vue' //工厂管理
import DealerManage from '@/view/system/businessManage/dealerManage.vue' //经销商管理
import PlasticAccountManage from '@/view/system/businessManage/plasticAccountManage.vue' //塑业帐号管理
//物料管理
import MaterialBrand from '@/view/system/materialCenter/materialBrand.vue' //物料品牌
import MaterialManage from '@/view/system/materialCenter/materialManage.vue' //物料管理
//追溯码管理
import TraceCodeList from '@/view/system/traceCodeManage/traceCodeList.vue' //追溯码
import SingleCodeQuery from '@/view/system/traceCodeManage/singleCodeQuery.vue' //追溯码查询
//扫码页管理
import BrandPromotion from '@/view/system/scanManage/brandPromotion.vue' //品牌推广
import ScanTemplete from '@/view/system/scanManage/scanTemplete.vue' //扫码模板
import SystemCompanyInfo from '@/view/system/scanManage/companyInfo'
//窜货管理
import FeelingSet from '@/view/system/feelingInfo/feelingSet.vue' //窜货设置
import FeelingStatistics from '@/view/system/feelingInfo/feelingStatistics.vue' //窜货统计
import FeelingDetails from '@/view/system/feelingInfo/feelingDetails.vue' //窜货明细


import Page404 from '@/view/404.vue'



// 网站
const routes = [{
        path: '',
        redirect: '/admin'
    },
    //企业管理系统--企业端
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: ForgetPassword
    },
    {
        path: '/user/home',
        component: Home,
        name: 'home',
        redirect: '/user/home/homeindex',
        meta: {
            type: 'login'
        },
        children: [{
                path: 'homeindex',
                name: 'homeindex',
                component: Homeindex,
                meta: {
                    anotherName: '首页',
                    type: 'login',
                    affix: true
                },
            },
            {
                path: 'companyOrgManage',
                name: 'companyOrgManage',
                component: CompanyOrgManage,
                meta: {
                    anotherName: '机构管理',
                    type: 'login'
                },
            },
            {
                path: 'companyPositionManage',
                name: 'companyPositionManage',
                component: CompanyPositionManage,
                meta: {
                    anotherName: '职务管理',
                    type: 'login'
                },
            },
            {
                path: 'companyRolesManage',
                name: 'companyRolesManage',
                component: CompanyRolesManage,
                meta: {
                    anotherName: '角色权限配置',
                    type: 'login'
                },
            },
            {
                path: 'companyPersonManage',
                name: 'companyPersonManage',
                component: CompanyPersonManage,
                meta: {
                    anotherName: '人员管理',
                    type: 'login'
                },
            },
            {
                path: 'companychangePassword',
                name: 'companychangePassword',
                component: CompanyChangePassword,
                meta: {
                    anotherName: '修改密码',
                    type: 'login'
                },
            },
            {
                path: 'traceCode',
                name: 'traceCode',
                component: TraceCode,
                meta: {
                    anotherName: '码申请下载',
                    type: 'login'
                },
            }, {
                path: 'traceCodeQuery',
                name: 'traceCodeQuery',
                component: TraceCodeQuery,
                meta: {
                    anotherName: '码关联查询',
                    type: 'login',
                },
            }, {
                path: 'inWarehouse',
                name: 'inWarehouse',
                component: InWarehouse,
                meta: {
                    anotherName: '入库管理',
                    type: 'login',
                },
            }, {
                path: 'outWarehouse',
                name: 'outWarehouse',
                component: OutWarehouse,
                meta: {
                    anotherName: '出库管理',
                    type: 'login',
                },
            }, {
                path: 'stockManage',
                name: 'stockManage',
                component: StockManage,
                meta: {
                    anotherName: '库存管理',
                    type: 'login',
                },
            },
        ],

    },
    
    {
        path: '/88.493.8000/bt/:id',
        component: ScanIndex,
    },
    // {
    //     path: '/88.493.8001/bt/:id',
    //     component: ScanIndex,
    // },
    // {
    //     path: '/88.493.8002/bt/:id',
    //     component: ScanIndex,
    // },
    // {
    //     path: '/88.493.8003/bt/:id',
    //     component: ScanIndex,
    // },
    // {
    //     path: '/88.493.8004/bt/:id',
    //     component: ScanIndex,
    // },
    {
        path: '/scan/:id',
        component: ScanIndex,
    },
    {
        path: '/scan0/:id',
        component: Scan0
    },
    {
        path: '/scan1/:id',
        component: Scan1,
    },

    {
        path: '/scan-companyInfo/:id',
        component: ScanCompanyInfo,
        name: '企业信息',
        meta: {}
    },
    {
        path: '/scan-branding/:id',
        component: ScanBranding,
        name: '品牌推广',
        meta: {}
    },
    {
        path: '/scan-traceability/:id',
        component: ScanTraceability,
        name: "溯源信息",
        meta: {}
    },


    // 后台管理系统admin--运营端
    {
        path: '/admin',
        name: 'admin',
        component: SystemLogin
    },
    {
        path: '/admin/home',
        component: SystemIndex,
        meta: {
            sysType: 'login',
        },
        children: [{
                path: 'index',
                name: 'index',
                component: SyStemHomeindex,
                meta: {
                    anotherName: '首页',
                    sysType: 'login',
                    affixType: true
                },
            }, {
                path: 'companyInfo',
                name: 'companyInfo',
                component: SystemCompanyInfo,
                meta: {
                    anotherName: '企业信息管理',
                    sysType: 'login'
                },
            }, {
                path: 'orgManage',
                name: 'orgManage',
                component: OrgManage,
                meta: {
                    anotherName: '机构管理',
                    type: 'login'
                },
            }, {
                path: 'positionManage',
                name: 'positionManage',
                component: PositionManage,
                meta: {
                    anotherName: '职务管理',
                    type: 'login'
                },
            }, {
                path: 'personManage',
                name: 'personManage',
                component: PersonManage,
                meta: {
                    anotherName: '人员管理',
                    type: 'login'
                },
            }, {
                path: 'rolesPower',
                name: 'rolesPower',
                component: RolesPower,
                meta: {
                    anotherName: '角色权限设置',
                    type: 'login'
                },
            }, {
                path: 'changePassword',
                name: 'changePassword',
                component: ChangePassword,
                meta: {
                    anotherName: '修改密码',
                    type: 'login'
                },
            }, {
                path: 'systemRolesPage',
                name: 'systemRolesPage',
                component: SystemRolesPage,
                meta: {
                    anotherName: '系统角色',
                    type: 'login'
                },
            }, {
                path: 'companyUserPage',
                name: 'companyUserPage',
                component: CompanyUserPage,
                meta: {
                    anotherName: '企业角色',
                    type: 'login'
                },
            },
            {
                path: 'companyUserSonPage',
                name: 'companyUserSonPage',
                component: CompanyUserSonPage,
                meta: {
                    anotherName: '企业角色子集列表',
                    type: 'login',
                    showType: false
                }
            },
            {
                path: 'navigationSystemPage',
                name: 'navigationSystemPage',
                component: NavigationSystemPage,
                meta: {
                    anotherName: '系统导航',
                    type: 'login',
                }
            },
            {
                path: 'navigationCompanyPage',
                name: 'navigationCompanyPage',
                component: NavigationCompanyPage,
                meta: {
                    anotherName: '企业导航',
                    type: 'login',
                }
            }, {
                path: 'buttonsManage',
                name: 'buttonsManage',
                component: ButtonsManage,
                meta: {
                    anotherName: '按钮管理',
                    type: 'login',
                }
            }, {
                path: 'scanTemplete',
                name: 'scanTemplete',
                component: ScanTemplete,
                meta: {
                    anotherName: '扫码模板管理',
                    type: 'login',
                }
            }, {
                path: 'brandPromotion',
                name: 'brandPromotion',
                component: BrandPromotion,
                meta: {
                    anotherName: '品牌推广',
                    type: 'login',
                }
            }, {
                path: 'inWarehouse',
                name: 'inWarehouse',
                component: FatoryInWarehouse,
                meta: {
                    anotherName: '入库管理',
                    type: 'login',
                }
            }, {
                path: 'outWarehouse',
                name: 'outWarehouse',
                component: FatoryOutWarehouse,
                meta: {
                    anotherName: '出库管理',
                    type: 'login',
                }
            }, {
                path: 'stockManage',
                name: 'stockManage',
                component: FatoryStockManage,
                meta: {
                    anotherName: '库存查询',
                    type: 'login',
                }
            }, {
                path: 'factoryManage',
                name: 'factoryManage',
                component: FactoryManage,
                meta: {
                    anotherName: '工厂管理',
                    type: 'login',
                }
            }, {
                path: 'dealerManage',
                name: 'dealerManage',
                component: DealerManage,
                meta: {
                    anotherName: '经销商管理',
                    type: 'login',
                }
            }, {
                path: 'plasticAccountManage',
                name: 'plasticAccountManage',
                component: PlasticAccountManage,
                meta: {
                    anotherName: '塑业帐号管理',
                    type: 'login',
                }
            }, {
                path: 'materialBrand',
                name: 'materialBrand',
                component: MaterialBrand,
                meta: {
                    anotherName: '物料品牌',
                    type: 'login',
                }
            }, {
                path: 'materialManage',
                name: 'materialManage',
                component: MaterialManage,
                meta: {
                    anotherName: '物料管理',
                    type: 'login',
                }
            }, {
                path: 'traceCodeList',
                name: 'traceCodeList',
                component: TraceCodeList,
                meta: {
                    anotherName: '追溯码信息',
                    type: 'login',
                }
            }, {
                path: 'singleCodeQuery',
                name: 'singleCodeQuery',
                component: SingleCodeQuery,
                meta: {
                    anotherName: '单码查询',
                    type: 'login',
                }
            }, {
                path: 'feelingSet',
                name: 'feelingSet',
                component: FeelingSet,
                meta: {
                    anotherName: '窜货预警设置',
                    type: 'login',
                }
            }, {
                path: 'feelingStatistics',
                name: 'feelingStatistics',
                component: FeelingStatistics,
                meta: {
                    anotherName: '窜货统计',
                    type: 'login',
                }
            }, {
                path: 'feelingDetails',
                name: 'feelingDetails',
                component: FeelingDetails,
                meta: {
                    anotherName: '窜货明细',
                    type: 'login',
                    showType: false,
                }
            },
        ]
    },

    {
        path: '/404',
        name: '404',
        component: Page404,
        hidden: true
    },
    {
        path: '*',
        redirect: '/404',
        hidden: true
    },

]

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({
        y: 0
    }),
    routes
})
export default router


// WEBPACK FOOTER //
// ./src/router/router.js